import { render } from "./deal-reports.vue?vue&type=template&id=24772949"
import script from "./deal-reports.vue?vue&type=script&lang=js"
export * from "./deal-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__